// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"f80cc78f","404":"69853fbb","787":"10e7df65"}[chunkId] + ".chunk.js";
};